var nurseslounge_lounges = {
    home:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_lounges.submenu($params, function(){
            if($params != null){
                var $menuIndex = $.inArray($params.typeName, ['employers','schools','nurseAssociations', 'states','specialties']);
                $(".nav-underline a:eq("+$menuIndex+")").click();
            }else{
                $(".nav-underline a:first").click();
            }
        });
    },
    home_sub:function($params){
        nurseslounge_lounges_home.init($params);
    },
    open:function($params){
        $(".nav-underline a").each(function(){
            if($(this).data('id') == $params.typeName){
                $(".nav-underline a").removeClass('active');
                $(this).addClass('active');
                router.pause();
                router.navigate('/lounges/'+$params.typeName);
                router.resume();
                $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
                libs.subrender($params.typeName, 'nurseslounge_lounges', 'home_sub', {typeName:$params.typeName}, 'POST');
                nurseslounge_lounges.menu_selector();
                nurseslounge_lounges.refreshTopMenu();
            }
        });
    },
    refreshTopMenu:function(){
        $(".top-area .main-menu li a").each(function(){
            var $that = $(this);
            $that.unbind().click(function(){
                if($that.attr('data-navigo') != undefined){
                    var $url = $that.data('url');
                    var $lounges = $url.split('/')[0];
                    var $typeName = $url.split('/')[1];
                    if($lounges == 'lounges' && $.inArray($typeName, ['employers','schools','nurseAssociations', 'states','specialties']) != -1){
                        var $params = $.extend({}, {typeName:$typeName}, {user_id:libs.memoryGet('user_id')});
                        nurseslounge_lounges.open($params);
                    }else{
                        router.resolve($url);
                    }
                }
            });
        });
    },
    submenu:function($params, cback){
        $(".nav-underline a").unbind().click(function(){
            $(".nav-underline a").removeClass('active');
            nurseslounge_lounges.submenu_open(this, $(this).data('url'),  'home_sub', {typeName:$(this).data('id')})
        });
        nurseslounge_lounges.menu_selector();
        nurseslounge_lounges.refreshTopMenu();
        cback();
    },
    submenu_open:function($this, $url, $module, $params){
        $($this).addClass('active');
        router.pause();
        router.navigate($url);
        router.resume();
        $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
        libs.subrender($url, 'nurseslounge_lounges', $module, $params, 'POST');
    },
    menu_selector:function(){
        libs.globalUrl();
    }
};
